var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { FeatureSwitches } from '../../../constants/feature-switches';
import { getWindow } from '../../../utils/general';
export var PHTableHeaderData = function (isAdminRole, pHRequest, searchByObj, selectedHeader, setPHRequest, sortDirection, tableHeaderState) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    var lineItemData = Object.prototype.hasOwnProperty.call(searchByObj, 'itemDescription');
    if (lineItemData) {
        // Line Item Data
        return [
            {
                title: 'Date',
                style: { width: '90px' },
                sort: false,
                sortProps: {
                    sortDirection: '',
                    ariaLabel: '',
                    active: false,
                    direction: undefined,
                    padding: '',
                    onClick: function () { return null; },
                    style: {},
                },
                showHeader: true,
            },
            {
                title: 'Item',
                style: { width: '70px' },
                sort: false,
                showHeader: true,
            },
            {
                title: 'Description',
                style: { width: '155px' },
                sort: false,
                showHeader: true,
            },
            {
                title: 'Order #',
                style: { width: '119px' },
                sort: false,
                showHeader: true,
            },
            {
                title: 'Receipt #',
                style: { width: '119px' },
                sort: false,
                showHeader: true,
            },
            {
                title: 'Qty',
                style: { width: '48px' },
                sort: false,
                showHeader: true,
            },
            {
                title: 'Unit Price',
                style: { width: '106px' },
                sort: false,
                showHeader: true,
            },
            {
                title: 'Discount',
                style: { width: '89px' },
                sort: false,
                showHeader: true,
            },
            {
                title: 'Net Unit Price',
                style: { width: '115px' },
                sort: false,
                showHeader: true,
            },
        ];
    }
    return [
        {
            title: 'Products',
            style: { minWidth: '132px' },
            sort: false,
            showHeader: (_a = tableHeaderState === null || tableHeaderState === void 0 ? void 0 : tableHeaderState[0]) === null || _a === void 0 ? void 0 : _a.enabled,
        },
        {
            title: 'Order/\nReceipt #',
            style: { minWidth: '132px' },
            sort: false,
            sortProps: {
                sortDirection: selectedHeader === 'orderNumber' ? sortDirection : undefined,
                ariaLabel: 'Sort by order number',
                active: selectedHeader === 'orderNumber',
                direction: sortDirection,
                padding: 'none',
                onClick: function () {
                    setPHRequest(__assign(__assign({}, pHRequest), { sortBy: 'orderNumber', sortOrder: sortDirection === 'asc' ? 'desc' : 'asc' }));
                },
                style: { paddingLeft: '0px' },
            },
            showHeader: (_b = tableHeaderState === null || tableHeaderState === void 0 ? void 0 : tableHeaderState[1]) === null || _b === void 0 ? void 0 : _b.enabled,
        },
        {
            title: 'Date',
            style: { minWidth: '100px' },
            sort: true,
            sortProps: {
                sortDirection: selectedHeader === 'salesDate' ? sortDirection : undefined,
                ariaLabel: 'Sort by sales date',
                active: selectedHeader === 'salesDate',
                direction: sortDirection,
                padding: 'none',
                onClick: function () {
                    setPHRequest(__assign(__assign({}, pHRequest), { sortBy: 'salesDate', sortOrder: sortDirection === 'asc' ? 'desc' : 'asc' }));
                },
                style: { paddingLeft: '0px', paddingRight: '34px' },
            },
            showHeader: (_c = tableHeaderState === null || tableHeaderState === void 0 ? void 0 : tableHeaderState[2]) === null || _c === void 0 ? void 0 : _c.enabled,
        },
        {
            title: 'Origin',
            style: { minWidth: '101px' },
            sort: false,
            sortProps: {
                sortDirection: selectedHeader === 'storeNumber' ? sortDirection : undefined,
                ariaLabel: 'Sort by store number',
                active: selectedHeader === 'storeNumber',
                direction: sortDirection,
                padding: 'none',
                onClick: function () {
                    setPHRequest(__assign(__assign({}, pHRequest), { sortBy: 'storeNumber', sortOrder: sortDirection === 'asc' ? 'desc' : 'asc' }));
                },
                style: { paddingLeft: '0px' },
            },
            showHeader: (_d = tableHeaderState === null || tableHeaderState === void 0 ? void 0 : tableHeaderState[3]) === null || _d === void 0 ? void 0 : _d.enabled,
        },
        {
            title: 'Project name',
            style: { minWidth: '110px' },
            sort: false,
            sortProps: {
                sortDirection: selectedHeader === 'projectName' ? sortDirection : undefined,
                ariaLabel: 'Sort by project name',
                active: selectedHeader === 'projectName',
                direction: sortDirection,
                padding: 'none',
                onClick: function () {
                    setPHRequest(__assign(__assign({}, pHRequest), { sortBy: 'projectName', sortOrder: sortDirection === 'asc' ? 'desc' : 'asc' }));
                },
                style: { paddingLeft: '0px', textAlign: 'left' },
            },
            showHeader: (_f = (_e = tableHeaderState === null || tableHeaderState === void 0 ? void 0 : tableHeaderState[4]) === null || _e === void 0 ? void 0 : _e.enabled) !== null && _f !== void 0 ? _f : true,
        },
        {
            title: 'PO/Job \nName',
            style: { minWidth: '124px' },
            sort: false,
            sortProps: {
                sortDirection: selectedHeader === 'POJobName' ? sortDirection : undefined,
                ariaLabel: 'Sort by POJobName',
                active: selectedHeader === 'POJobName',
                direction: sortDirection,
                padding: 'none',
                onClick: function () {
                    setPHRequest(__assign(__assign({}, pHRequest), { sortBy: 'POJobName', sortOrder: sortDirection === 'asc' ? 'desc' : 'asc' }));
                },
                style: { paddingLeft: '0px', textAlign: 'left' },
            },
            showHeader: (_g = tableHeaderState === null || tableHeaderState === void 0 ? void 0 : tableHeaderState[5]) === null || _g === void 0 ? void 0 : _g.enabled,
        },
        {
            title: 'Payment',
            style: { minWidth: '128px' },
            sort: false,
            sortProps: {
                sortDirection: selectedHeader === 'totalAmount' ? sortDirection : undefined,
                ariaLabel: 'Sort by total amount',
                active: selectedHeader === 'totalAmount',
                direction: sortDirection,
                padding: 'none',
                onClick: function () {
                    setPHRequest(__assign(__assign({}, pHRequest), { sortBy: 'totalAmount', sortOrder: sortDirection === 'asc' ? 'desc' : 'asc' }));
                },
                style: { paddingLeft: '0px' },
            },
            showHeader: (_h = tableHeaderState === null || tableHeaderState === void 0 ? void 0 : tableHeaderState[6]) === null || _h === void 0 ? void 0 : _h.enabled,
        },
        {
            title: 'Purchaser',
            style: { minWidth: '112px', textAlign: 'left' },
            sort: false,
            isAdmin: isAdminRole,
            showHeader: (_j = tableHeaderState === null || tableHeaderState === void 0 ? void 0 : tableHeaderState[7]) === null || _j === void 0 ? void 0 : _j.enabled,
        },
        {
            title: 'Nickname',
            style: { minWidth: '112px', textAlign: 'left' },
            sort: false,
            showHeader: (_k = tableHeaderState === null || tableHeaderState === void 0 ? void 0 : tableHeaderState[8]) === null || _k === void 0 ? void 0 : _k.enabled,
        },
        {
            title: 'Total',
            style: { minWidth: '97px' },
            sort: false,
            sortProps: {
                sortDirection: selectedHeader === 'totalAmount' ? sortDirection : undefined,
                ariaLabel: 'Sort by total amount',
                active: selectedHeader === 'totalAmount',
                direction: sortDirection,
                padding: 'none',
                onClick: function () {
                    setPHRequest(__assign(__assign({}, pHRequest), { sortBy: 'totalAmount', sortOrder: sortDirection === 'asc' ? 'desc' : 'asc' }));
                },
                style: { paddingLeft: '0px' },
            },
            showHeader: (_l = tableHeaderState === null || tableHeaderState === void 0 ? void 0 : tableHeaderState[9]) === null || _l === void 0 ? void 0 : _l.enabled,
        },
    ];
};
export var PHTableHeaderValues = function () {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z;
    var tableHeaderValuesLocalStorage = (_c = (_b = (_a = getWindow()) === null || _a === void 0 ? void 0 : _a.sessionStorage) === null || _b === void 0 ? void 0 : _b.getItem('tableHeaders')) !== null && _c !== void 0 ? _c : '';
    var tableHeaderValues;
    try {
        tableHeaderValues = tableHeaderValuesLocalStorage
            ? JSON.parse(tableHeaderValuesLocalStorage)
            : undefined;
    }
    catch (jsonParseError) {
        tableHeaderValues = undefined;
    }
    return [
        {
            columnName: 'Product Images',
            enabled: (_e = (_d = tableHeaderValues === null || tableHeaderValues === void 0 ? void 0 : tableHeaderValues[0]) === null || _d === void 0 ? void 0 : _d.enabled) !== null && _e !== void 0 ? _e : true,
            showToggle: true,
        },
        {
            columnName: 'Order/Receipt Number',
            enabled: (_g = (_f = tableHeaderValues === null || tableHeaderValues === void 0 ? void 0 : tableHeaderValues[1]) === null || _f === void 0 ? void 0 : _f.enabled) !== null && _g !== void 0 ? _g : true,
            showToggle: true,
        },
        {
            columnName: 'Date',
            enabled: (_j = (_h = tableHeaderValues === null || tableHeaderValues === void 0 ? void 0 : tableHeaderValues[2]) === null || _h === void 0 ? void 0 : _h.enabled) !== null && _j !== void 0 ? _j : true,
            showToggle: true,
        },
        {
            columnName: 'Origin (Location of Purchase)',
            enabled: (_l = (_k = tableHeaderValues === null || tableHeaderValues === void 0 ? void 0 : tableHeaderValues[3]) === null || _k === void 0 ? void 0 : _k.enabled) !== null && _l !== void 0 ? _l : false,
            showToggle: true,
        },
        {
            columnName: 'Project Name',
            enabled: (FeatureSwitches === null || FeatureSwitches === void 0 ? void 0 : FeatureSwitches.enableProjectName) &&
                ((_o = (_m = tableHeaderValues === null || tableHeaderValues === void 0 ? void 0 : tableHeaderValues[4]) === null || _m === void 0 ? void 0 : _m.enabled) !== null && _o !== void 0 ? _o : false),
            showToggle: (_p = FeatureSwitches === null || FeatureSwitches === void 0 ? void 0 : FeatureSwitches.enableProjectName) !== null && _p !== void 0 ? _p : true,
        },
        {
            columnName: 'PO/Job Name',
            enabled: (_r = (_q = tableHeaderValues === null || tableHeaderValues === void 0 ? void 0 : tableHeaderValues[5]) === null || _q === void 0 ? void 0 : _q.enabled) !== null && _r !== void 0 ? _r : true,
            showToggle: true,
        },
        {
            columnName: 'Payment',
            enabled: (_t = (_s = tableHeaderValues === null || tableHeaderValues === void 0 ? void 0 : tableHeaderValues[6]) === null || _s === void 0 ? void 0 : _s.enabled) !== null && _t !== void 0 ? _t : true,
            showToggle: true,
        },
        {
            columnName: 'Purchaser/Buyer',
            enabled: (_v = (_u = tableHeaderValues === null || tableHeaderValues === void 0 ? void 0 : tableHeaderValues[7]) === null || _u === void 0 ? void 0 : _u.enabled) !== null && _v !== void 0 ? _v : true,
            showToggle: true,
        },
        {
            columnName: 'Nickname (Payment Nickname)',
            enabled: (_x = (_w = tableHeaderValues === null || tableHeaderValues === void 0 ? void 0 : tableHeaderValues[8]) === null || _w === void 0 ? void 0 : _w.enabled) !== null && _x !== void 0 ? _x : false,
            showToggle: true,
        },
        {
            columnName: 'Total',
            enabled: (_z = (_y = tableHeaderValues === null || tableHeaderValues === void 0 ? void 0 : tableHeaderValues[9]) === null || _y === void 0 ? void 0 : _y.enabled) !== null && _z !== void 0 ? _z : true,
            showToggle: true,
        },
    ];
};
